<template>
  <aside class="main-sidebar">
    <section class="sidebar">

      <ul class="sidebar-menu tree" data-widget="tree">
        <li class="header">{{$t('menu.header')}}</li>

        <li v-bind:class="{ active: active == 'dashboard' }">
          <a href="../"><i class="fa fa-link"></i> <span>{{$t('menu.dashboard')}}</span></a>
        </li>
        <li v-bind:class="{ active: active === 'camps' }" >
          <a href="../camps"><i class="fa fa-link"></i> <span>{{$t('menu.camps')}}</span></a>
        </li>

        <li v-bind:class="{ active: active === 'programs' }" >
          <a href="../programs"><i class="fa fa-link"></i> <span>{{$t('menu.programs')}}</span></a>
        </li>

<!--        <li v-if="isBackoffice()" v-bind:class="{ active: active === 'orders' }" >-->
<!--          <a href="../orders"><i class="fa fa-link"></i> <span>{{$t('menu.orders')}}</span></a>-->
<!--        </li>-->
      </ul>
    </section>
  </aside>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    active: String
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    }
  }
};
</script>

<style scoped>

</style>
